import React from 'react';
import PropTypes from 'prop-types';
import { GridItem } from '@bnnvara/grids';
import Share from '@bnnvara/share';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { getHostname } from '../../helpers/getHostname';
import { useFingerprint } from '../../hooks/fingerprint';
import { stripQueryParams } from '../../helpers/stripQueryParams';
import { utmParams } from '../../helpers/utmParams';

import * as S from './styled';
import { CREATE_SHARE } from '../../api/mutations/share.gql';

const socials = ['facebook', 'twitter', 'linkedin', 'whatsapp', 'mail'];

const ShareContainer = ({ id, type }) => {
  const [createShare] = useMutation(CREATE_SHARE);
  const router = useRouter();
  const fingerprint = useFingerprint();
  const { id: brandId } = useBrand();
  const utm = utmParams();

  const handleClick = ({ contentId, platform }) => {
    track(`share-${platform}`, 'click', contentId);

    createShare({
      variables: {
        contentId,
        contentType: type,
        platform,
        fingerprint,
        brandId,
        slug: stripQueryParams(router.asPath),
        utm,
      },
    });
  };

  return (
    <GridItem columnStartSm="1" columnEndSm="-1">
      <S.ShareContainer>
        <span aria-label="Delen">Delen:</span>

        {socials.map((value) => (
          <Share
            id={id}
            key={value}
            platform={value}
            link={`${getHostname()}${router.asPath}`}
            handleClick={handleClick}
          />
        ))}
      </S.ShareContainer>
    </GridItem>
  );
};

export default ShareContainer;

ShareContainer.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
};
